var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback } from "react";
import styles from "./OptimizedImage.module.css";
var OptimizedImage = function (_a) {
    var src = _a.src, alt = _a.alt, className = _a.className, width = _a.width, height = _a.height, _b = _a.placeholder, placeholder = _b === void 0 ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkxvYWRpbmcuLi48L3RleHQ+PC9zdmc+" : _b;
    var _c = useState(placeholder), imageSrc = _c[0], setImageSrc = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(false), hasError = _e[0], setHasError = _e[1];
    var handleLoad = useCallback(function () {
        setIsLoading(false);
        setImageSrc(src);
    }, [src]);
    var handleError = useCallback(function () {
        setIsLoading(false);
        setHasError(true);
        setImageSrc(placeholder);
    }, [placeholder]);
    var getImageClasses = function () {
        var classes = "".concat(styles.image);
        if (isLoading)
            classes += " ".concat(styles.loading);
        if (!isLoading)
            classes += " ".concat(styles.loaded);
        if (hasError)
            classes += " ".concat(styles.error);
        return classes;
    };
    return (_jsxs("div", __assign({ className: "".concat(styles.container, " ").concat(className || "") }, { children: [_jsx("img", { src: imageSrc, alt: alt, width: width, height: height, onLoad: handleLoad, onError: handleError, className: getImageClasses() }), isLoading && _jsx("div", __assign({ className: styles.loadingOverlay }, { children: "Loading..." }))] })));
};
export default React.memo(OptimizedImage);
